import $ from 'jquery';

$( document ).ready( () => {
	if ( window.location.hash.indexOf( '#item-' ) === 0 ) {
		const $target = $( '#' + window.location.hash.substr( 1 ) );
		if ( $target.length ) {
			$target.parents( '.accordion' ).foundation( 'down', $target.find( '.accordion-content' ) );
		}
	}
} );
